import { Box, MediumIcon } from '@factorialco/deprecated-design-system'
import { IconType } from '@factorialco/f0-react'

import { observer } from 'mobx-react'

import useChangeView from 'modules/shift_management/hooks/useChangeView'

import { Selector } from './Content/index'
import { newThemeGroupTypeOptions } from './viewTypeOptions'

interface Props {
  disabled?: boolean
}

export interface Option {
  label: string
  value: string
  icon: MediumIcon
  newThemeIcon: IconType
  disabled?: boolean
}

const ViewSelector = observer(({ disabled = false }: Props) => {
  const { view, onChangeRoute } = useChangeView()

  const onGroupChange = (value: string) => {
    onChangeRoute(`${view.viewType}/${value}`)
  }

  return (
    <Box
      flexDirection="row"
      alignItems="center"
      justifyContent="center"
      width="full"
      paddingTop="s8"
      paddingBottom="s4"
      paddingLeft="s8"
      paddingRight="s8"
    >
      {newThemeGroupTypeOptions().map((option: Option) => (
        <Selector
          key={option.value}
          value={option.value}
          selectedValue={view.groupType}
          icon={option.newThemeIcon}
          label={option.label}
          onChange={onGroupChange}
        />
      ))}
    </Box>
  )
})

export { ViewSelector }
